import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { ErrorBoundary } from './components/ErrorBoundary';
import { ErrorTesterComponent } from './components/ErrorBoundary/ErrorTesterComponent';
import { ErrorReportingProvider } from './components/ErrorTracking/ErrorReportingProvider';
import AddListingPage from './pages/AddListingPage';
import AddTenantScreeningPage from './pages/AddTenantScreeningPage';
import ListingDetailPage from './pages/ListingDetailPage';
import ListingsPage from './pages/ListingsPage';

function App(): React.ReactElement {
  // In development, show error tester. In production, show the main app
  const showErrorTester =
    process.env.NODE_ENV === 'development' &&
    window.location.search.includes('test-errors');

  return (
    <ErrorReportingProvider>
      <ErrorBoundary
        onError={_error => {
          // Custom error handling can be added here
          // console.log('App-level error caught:', error);
        }}
      >
        {showErrorTester ? (
          <ErrorTesterComponent />
        ) : (
          <Router>
            <Routes>
              <Route path='/' element={<ListingsPage />} />
              <Route path='/add-listing' element={<AddListingPage />} />
              <Route
                path='/add-tenant-screening'
                element={<AddTenantScreeningPage />}
              />
              <Route path='/listing/:id' element={<ListingDetailPage />} />
            </Routes>
          </Router>
        )}
      </ErrorBoundary>
    </ErrorReportingProvider>
  );
}

export default App;
